// <copyright file="delivery-batch.ts" company="SoftTech Ltd">
// Copyright (c) SoftTech Ltd. All rights reserved.
// </copyright>

/**
 * Whether a candidate item belongs to the delivery being viewed. When that delivery carries a
 * batch id, membership is sharing the same batch; when it does not - a row delivered before batch
 * ids existed - the delivery is just the single clicked item. Kept pure and shared so the job
 * items table and the quote items table decide "what went out together" the same way.
 */
export function isSameDeliveryBatch(
  candidateBatchId: string | null | undefined,
  candidateQuoteItemId: string,
  viewedBatchId: string | null | undefined,
  clickedQuoteItemId: string
): boolean {
  return viewedBatchId ? candidateBatchId === viewedBatchId : candidateQuoteItemId === clickedQuoteItemId;
}
